import React, { useEffect, useRef } from "react";
import * as Cesium from "cesium";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import AuthServiceV3 from "../../../services/Operation.serviceV3.js";
import * as turf from "@turf/turf";
import greenDrone from "../../../picture/Borderized-Green-Drone.png";
import yellowDrone from "../../../picture/Borderized-Yellow-Drone.png";
import greyDrone from "../../../picture/Borderized-Grey-Drone.png";
import redDrone from "../../../picture/Borderized-Red-Drone.png";

const DroneMonitor = () => {
  Cesium.Ion.defaultAccessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4YTkzY2UxMS1kMzE1LTQ5OTgtYjZjYS1lYjQ0ZmI2M2Q5ODMiLCJpZCI6MTAyMzYwLCJpYXQiOjE2NTg3MTU3NzZ9.JRrIwyF6xYiIdmIiP9ezmq4siqacN1K6ObnYnjpfHVc";
  const mapRef = useRef(null);

  useEffect(() => {
    Cesium.Ion.defaultAccessToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4ZjMzYjE4Yi0yOTdjLTQwM2QtYTE1ZC03NmVlOWYxYTkwOWMiLCJpZCI6MTQ1NDE4LCJpYXQiOjE2ODYyMDU1MjF9.v9-Cb1DuW8J1rrEXixkabo69xxSEkS_729lv7vtBba8";
    // const socket = new WebSocket("ws://172.27.184.102:6080");
    const viewer = new Cesium.Viewer(mapRef.current, {
      scene3DOnly: true,
      timeline: false,
      animation: false,
      baseLayerPicker: true,
      selectionIndicator: false,
      infoBox: true,
    });
    viewer.scene.globe.depthTestAgainstTerrain = false;
    viewer.shadows = false;
    viewer.scene.fog.enabled = false;
    viewer.scene.skyAtmosphere.show = false;
    viewer.resolutionScale = 0.7; // Lower the resolution scale for better performance
    viewer.scene.globe.enableLighting = false;
    viewer.targetFrameRate = 60;

    const handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    viewer.scene.screenSpaceCameraController.enableRotate = true;
    viewer.scene.screenSpaceCameraController.enableTranslate = true;
    viewer.scene.screenSpaceCameraController.enableZoom = true;
    viewer.scene.screenSpaceCameraController.enableTilt = false;
    viewer.scene.screenSpaceCameraController.enableLook = false;

    let anchorPointLon = 0;
    let anchorPointLat = 0;
    let userLat;
    let userLon;

    flyToLocation();
    function flyToLocation() {
      function fly(position) {
        viewer.camera.setView({
          destination: Cesium.Cartesian3.fromDegrees(
            position.coords.longitude,
            position.coords.latitude,
            1000.0
          ),
        });
        showCoordinates(position.coords.longitude, position.coords.latitude);
        userLat = position.coords.latitude;
        userLon = position.coords.longitude;
      }
      navigator.geolocation.getCurrentPosition(fly);
    }

    handler.setInputAction(function (movement) {
      const pickedObject = viewer.scene.pick(movement.position);
      if (Cesium.defined(pickedObject) && Cesium.defined(pickedObject.id)) {
        isClicking = pickedObject.id.id.split("-")[1];
      } else {
        isClicking = null;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    const onMessageData = {};
    const entityMap = {};
    const updatingData = {};
    const headingCoordinates = {};
    let isClicking = null;
    const flightAreaInTime = [];
    const flightAreaEntities = [];
    const clusterEntities = {};

    function getDescription(
      id,
      name,
      speed,
      height,
      headDirection,
      dataTimeStamp
    ) {
      let showHeight;
      if (height < 0) {
        showHeight = 0;
      } else {
        showHeight = height;
      }
      const date = new Date((dataTimeStamp + 7 * 3600) * 1000);
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");
      const formattedTime = `${hours}:${minutes}:${seconds}`;
      return (
        "<table class='cesium-infoBox-defaultTable'>" +
        "<tr>" +
        "<th>Content</th>" +
        "<th>Value</th>" +
        "</tr>" +
        "<tr>" +
        "<td>Drone ID</td>" +
        `<td>${id}</td>` +
        "</tr>" +
        "<tr>" +
        "<tr>" +
        "<td>Drone Name</td>" +
        `<td>${name}</td>` +
        "</tr>" +
        "<tr>" +
        "<td>Height</td>" +
        `<td>${showHeight} m</td>` +
        "</tr>" +
        "<tr>" +
        "<td>Heading Degree</td>" +
        `<td>${headDirection}</td>` +
        "</tr>" +
        "<tr>" +
        "<td>Timestamp</td>" +
        `<td>${formattedTime}</td>` +
        "</tr>" +
        "</table>"
      );
    }

    let actualBorderPolygon = viewer.entities.add({
      name: "Border actual display",
      polygon: null,
    });
    let blurBorderPolygon = viewer.entities.add({
      name: "Border blur display",
      polygon: null,
    });
    function showCoordinates(longitude, latitude) {
      anchorPointLon = longitude;
      anchorPointLat = latitude;

      actualBorderPolygon.polygon = {
        hierarchy: {
          positions: Cesium.Cartesian3.fromDegreesArray([
            longitude + 0.095,
            latitude + 0.095,
            longitude - 0.095,
            latitude + 0.095,
            longitude - 0.095,
            latitude - 0.095,
            longitude + 0.095,
            latitude - 0.095,
          ]),
          holes: [
            {
              positions: Cesium.Cartesian3.fromDegreesArray([
                longitude - 0.0948,
                latitude - 0.0948,
                longitude + 0.0948,
                latitude - 0.0948,
                longitude + 0.0948,
                latitude + 0.0948,
                longitude - 0.0948,
                latitude + 0.0948,
              ]),
            },
          ],
        },
        material: Cesium.Color.RED.withAlpha(0.5),
        height: 0,
        outline: true,
        outlineColor: Cesium.Color.RED,
      };

      function getFlightArea(s_coord, e_coord) {
        const currentTime = new Date();
        const currentTimePlus7 = new Date(
          currentTime.getTime() + 7 * 60 * 60 * 1000
        );
        const stringTimePlus7 = `${currentTimePlus7
          .toISOString()
          .slice(0, 19)}+07:00`;

        const next3Hours = new Date(
          currentTimePlus7.getTime() + 3 * 60 * 60 * 1000
        );
        const stringNext3Hours = `${next3Hours
          .toISOString()
          .slice(0, 19)}+07:00`;

        AuthServiceV2.AreaSpecificTime(
          stringTimePlus7,
          stringNext3Hours,
          s_coord,
          e_coord
        )
          .then((response) => {
            const areaData = response.data.data;
            areaData.map((content, _) => {
              if (
                new Date() > new Date(content.operation_start_time) &&
                new Date() < new Date(content.operation_end_time)
              ) {
                const areaEntities = viewer.entities.add({
                  id: `${content.operation_code}`,
                  name: `${content.operation_code}`,
                  description: `<p>นักบิน : ${content.pilot_name}</p><p>ผู้ปฏิบัติการ : ${content.operator_name}</p>
                  <p>เวลาเริ่มต้น : ${content.operation_start_time}</p><p>เวลาสิ้นสุด : ${content.operation_end_time}</p>`,
                  polygon: {
                    hierarchy: Cesium.Cartesian3.fromDegreesArray(
                      extractCoordinates(
                        content.area_new_format,
                        content.remoteid_serial_number,
                        content.operation_start_time,
                        content.operation_end_time
                      ).flat()
                    ),
                    material: Cesium.Color.YELLOWGREEN.withAlpha(0.5),
                    height: 10,
                    outline: true,
                    outlineWidth: 5,
                    outlineColor: Cesium.Color.BLACK,
                  },
                });
                flightAreaEntities.push(areaEntities);
              }
              return 0;
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }

      function extractCoordinates(array, remote_id, start_time, end_time) {
        const extractedData = array.map((item) => [item.Lon, item.Lat]);
        flightAreaInTime.push({
          area: [extractedData],
          remote_id: remote_id,
          start_time: start_time,
          end_time: end_time,
        });
        return extractedData;
      }

      if (flightAreaEntities.length === 0) {
        getFlightArea(
          `${longitude + 0.095},${latitude + 0.095}`,
          `${longitude - 0.095},${latitude - 0.095}`
        );
      }

      setInterval(function () {
        if (flightAreaEntities.length > 0) {
          flightAreaEntities.map((content, _) => {
            viewer.entities.removeById(content._id);
            return 0;
          });
          flightAreaEntities.length = 0;
          flightAreaInTime.length = 0;
        }
        getFlightArea(
          `${longitude + 0.095},${latitude + 0.095}`,
          `${longitude - 0.095},${latitude - 0.095}`
        );
      }, 60000);

      blurBorderPolygon.polygon = {
        hierarchy: {
          positions: Cesium.Cartesian3.fromDegreesArray([
            longitude + 0.02,
            latitude + 0.02,
            longitude - 0.02,
            latitude + 0.02,
            longitude - 0.02,
            latitude - 0.02,
            longitude + 0.02,
            latitude - 0.02,
          ]),
          holes: [
            {
              positions: Cesium.Cartesian3.fromDegreesArray([
                longitude - 0.0198,
                latitude - 0.0198,
                longitude + 0.0198,
                latitude - 0.0198,
                longitude + 0.0198,
                latitude + 0.0198,
                longitude - 0.0198,
                latitude + 0.0198,
              ]),
            },
          ],
        },
        material: Cesium.Color.YELLOW.withAlpha(0.5),
        height: 0,
        outline: true,
        outlineColor: Cesium.Color.YELLOW,
      };
    }

    function calculateHeading(droneId, lon, lat) {
      if (!headingCoordinates.hasOwnProperty(droneId)) {
        headingCoordinates[droneId] = { lon, lat };
        return null;
      }

      const toRadians = (degrees) => (degrees * Math.PI) / 180;
      const toDegrees = (radians) => (radians * 180) / Math.PI;

      const { lon: prevLon, lat: prevLat } = headingCoordinates[droneId];

      const dLon = toRadians(lon - prevLon);
      const lat1Rad = toRadians(prevLat);
      const lat2Rad = toRadians(lat);

      const y = Math.sin(dLon) * Math.cos(lat2Rad);
      const x =
        Math.cos(lat1Rad) * Math.sin(lat2Rad) -
        Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);
      const initialBearing = toDegrees(Math.atan2(y, x));

      headingCoordinates[droneId] = { lon, lat };

      return initialBearing;
    }

    function determineDirection(degree) {
      degree = parseInt(degree);
      if (degree < 0) {
        degree = 360 + (degree % 360);
      }

      if (degree >= 337.5 || degree < 22.5) {
        return `${degree}° (North)`;
      } else if (degree >= 22.5 && degree < 67.5) {
        return `${degree}° (North East)`;
      } else if (degree >= 67.5 && degree < 112.5) {
        return `${degree}° (East)`;
      } else if (degree >= 112.5 && degree < 157.5) {
        return `${degree}° (South East)`;
      } else if (degree >= 157.5 && degree < 202.5) {
        return `${degree}° (South)`;
      } else if (degree >= 202.5 && degree < 247.5) {
        return `${degree}° (South West)`;
      } else if (degree >= 247.5 && degree < 292.5) {
        return `${degree}° (West)`;
      } else if (degree >= 292.5 && degree < 337.5) {
        return `${degree}° (North West)`;
      }
    }

    function verifyDistancing(lon1, lat1, lon2, lat2) {
      const targetCoordinate = { lat: lat2, lon: lon2 };
      const cornerA = { lat: lat1 + 0.095, lon: lon1 + 0.095 };
      const cornerB = { lat: lat1 - 0.095, lon: lon1 - 0.095 };
      const cornerC = { lat: lat1 + 0.02, lon: lon1 + 0.02 };
      const cornerD = { lat: lat1 - 0.02, lon: lon1 - 0.02 };

      const minLatA = Math.min(cornerA.lat, cornerB.lat);
      const maxLatA = Math.max(cornerA.lat, cornerB.lat);
      const minLonA = Math.min(cornerA.lon, cornerB.lon);
      const maxLonA = Math.max(cornerA.lon, cornerB.lon);

      const minLatB = Math.min(cornerC.lat, cornerD.lat);
      const maxLatB = Math.max(cornerC.lat, cornerD.lat);
      const minLonB = Math.min(cornerC.lon, cornerD.lon);
      const maxLonB = Math.max(cornerC.lon, cornerD.lon);

      if (
        targetCoordinate.lat >= minLatA &&
        targetCoordinate.lat <= maxLatA &&
        targetCoordinate.lon >= minLonA &&
        targetCoordinate.lon <= maxLonA
      ) {
        if (
          targetCoordinate.lat >= minLatB &&
          targetCoordinate.lat <= maxLatB &&
          targetCoordinate.lon >= minLonB &&
          targetCoordinate.lon <= maxLonB
        ) {
          return "Inbound";
        } else {
          return "OutOfLimitedBound";
        }
      } else {
        return "OutOfBound";
      }
    }

    function validateTimeWithFlighting(id, position) {
      const currentTimeInterval = new Date();

      for (let index = 0; index < flightAreaInTime.length; index++) {
        const content = flightAreaInTime[index];
        const inFlightTime =
          currentTimeInterval >= new Date(content.start_time) &&
          currentTimeInterval <= new Date(content.end_time);

        const findIntersection = turf.booleanPointInPolygon(
          turf.point([position.lon, position.lat]),
          turf.polygon(content.area)
        );
        if (findIntersection) {
          if (id === content.remote_id && inFlightTime) {
            return 2; //Must be Green
          }
          else if (id !== content.remote_id && inFlightTime) {
            return 3; //Must be Red
          }
        }
      }
      return 0;
    }

    function returnImage(isInPlannedArea, name) {
    
      if (name !== "ไม่พบข้อมูลโดรน") {
        switch (isInPlannedArea) {
          case 2:
            return greenDrone;
            // break;
          case 3:
            return redDrone;
            // break;
          default:
            return yellowDrone
            // break
        }
      } else {
        switch (isInPlannedArea) {
          case 3:
            return redDrone;
            // break;
          default:
            return greyDrone
            // break
        }
      }
    }

    function clusterPositions(data, threshold) {
      const clusters = [];

      // Iterate through the data and calculate distances
      for (const id in data) {
        if (onMessageData[id].currentDegreePosition !== undefined) {
          const { x, y, z } = data[id].currentPosition;
          const { lon, lat } = data[id].currentDegreePosition;
          if (
            verifyDistancing(anchorPointLon, anchorPointLat, lon, lat) ===
            "OutOfLimitedBound"
          ) {
            let addedToCluster = false;

            for (const cluster of clusters) {
              const [cx, cy, cz] = cluster.center;
              const distance = Math.sqrt(
                (x - cx) ** 2 + (y - cy) ** 2 + (z - cz) ** 2
              );

              if (distance <= threshold) {
                cluster.members.push(data[id]);
                cluster.center = [
                  (cx * cluster.members.length + x) /
                    (cluster.members.length + 1),
                  (cy * cluster.members.length + y) /
                    (cluster.members.length + 1),
                  (cz * cluster.members.length + z) /
                    (cluster.members.length + 1),
                ];
                addedToCluster = true;
                break;
              }
            }

            if (!addedToCluster) {
              clusters.push({ center: [x, y, z], members: [data[id]] });
            }
          }
        }
      }
      return clusters;
    }

    // Function to update entities based on clusters
    function updateEntities(clusters) {
      for (const id in clusterEntities) {
        viewer.entities.remove(clusterEntities[id]); // Remove previous entities
      }

      clusters.forEach((cluster, index) => {
        if (cluster.members.length === 1) {
          const shiftPosition = Math.floor(Math.random() * 201) - 100;
          const { x, y, z } = cluster.members[0].currentPosition;
          clusterEntities[index] = viewer.entities.add({
            position: new Cesium.Cartesian3(
              x + shiftPosition,
              y + shiftPosition,
              z + shiftPosition
            ),
            ellipse: {
              semiMinorAxis: 250.0,
              semiMajorAxis: 250.0,
              material: Cesium.Color.RED.withAlpha(0.5),
            },
            label: {
              text: `1`,
              scale: 1,
            },
          });
        } else {
          const [x, y, z] = cluster.center;
          clusterEntities[index] = viewer.entities.add({
            position: new Cesium.Cartesian3(x, y, z),
            ellipse: {
              semiMinorAxis: 750.0,
              semiMajorAxis: 750.0,
              material: Cesium.Color.RED.withAlpha(0.5),
            },
            label: {
              text: `${cluster.members.length}`,
              scale: 1,
            },
          });
        }
      });
    }

    function updateRealTimeData(data) {
      const threshold = 750; // Define a distance threshold for clustering
      const clusters = clusterPositions(data, threshold);
      updateEntities(clusters);
    }
    const trailWidth = 3.0;

    setInterval(function () {
      AuthServiceV2.RealTimeData(userLat, userLon)
        .then((response) => {
          const flightData = response.data.flights;
          for (
            let flightStep = 0;
            flightStep < flightData.length;
            flightStep++
          ) {
            const actualFlightPosition =
              flightData[flightStep].recent_positions[0];
            const flightLatitude = parseFloat(
              actualFlightPosition.position.lat
            );
            const flightLongitude = parseFloat(
              actualFlightPosition.position.lon
            );

            const id = flightData[flightStep].id;
            updatingData[id] = 0;
            if (!entityMap[id]) {
              entityMap[id] = {}; // Initialize as an empty object if undefined
            }
            if (onMessageData.hasOwnProperty(id)) {
              onMessageData[id].lastPosition =
                onMessageData[id].currentPosition;

              onMessageData[id].lastDegreePosition =
                onMessageData[id].currentDegreePosition;

              let headDegree = calculateHeading(
                id,
                flightLongitude,
                flightLatitude
              );
              let headDirection = determineDirection(headDegree);
              onMessageData[id].headDirection = headDirection;

              onMessageData[id].lastUpdateTime = Cesium.JulianDate.now();

              onMessageData[id].currentPosition = Cesium.Cartesian3.fromDegrees(
                flightLongitude,
                flightLatitude,
                20
              );
              onMessageData[id].currentDegreePosition = {
                lon: flightLongitude,
                lat: flightLatitude,
              };

              onMessageData[id].height =
                actualFlightPosition.position.height.distance;
              onMessageData[id].time = Math.floor(
                new Date(actualFlightPosition.time.value).getTime() / 1000
              );
              onMessageData[id].speed =
                flightData[flightStep].current_state.speed;

              if (onMessageData[id].currentDegreePosition !== undefined) {
                if (
                  verifyDistancing(
                    anchorPointLon,
                    anchorPointLat,
                    flightLongitude,
                    flightLatitude
                  ) === "Inbound"
                ) {
                  const newPosition = Cesium.Cartesian3.fromDegrees(
                    flightLongitude,
                    flightLatitude,
                    20
                  );
                  if (
                    onMessageData[id].historyTrail.length === 0 ||
                    !Cesium.Cartesian3.equals(
                      newPosition,
                      onMessageData[id].historyTrail[
                        onMessageData[id].historyTrail.length - 1
                      ]
                    )
                  ) {
                    onMessageData[id].historyTrail.push(newPosition);
                  }
                }
              }
              onMessageData[id].trailLength = 0;
            } else {
              AuthServiceV3.RealTimeDrone(id)
                .then((response) => {
                  onMessageData[id].name = response.data.brand_model;
                })
                .catch((error) => {
                  console.log("Error finding Drone");
                });

              onMessageData[id] = {
                lastPosition: Cesium.Cartesian3.fromDegrees(
                  flightLongitude,
                  flightLatitude,
                  20
                ),
                currentPosition: Cesium.Cartesian3.fromDegrees(
                  flightLongitude,
                  flightLatitude,
                  20
                ),
                lastUpdateTime: Cesium.JulianDate.now(),
                historyTrail: [
                  Cesium.Cartesian3.fromDegrees(
                    flightLongitude,
                    flightLatitude,
                    20
                  ),
                ],
              };

              entityMap[id].flightObject = viewer.entities.add({
                id: `FO-${id}`,
                name: onMessageData[id].name,
                label: {
                  text: new Cesium.CallbackProperty((time) => {
                    if (onMessageData[id].currentDegreePosition !== undefined) {
                      if (
                        verifyDistancing(
                          anchorPointLon,
                          anchorPointLat,
                          onMessageData[id].currentDegreePosition.lon,
                          onMessageData[id].currentDegreePosition.lat
                        ) === "Inbound"
                      ) {
                        return onMessageData[id].name;
                      } else {
                        return null;
                      }
                    }
                  }, false),
                  font: "bold 35px Helvetica",
                  pixelOffset: new Cesium.Cartesian2(0, -60),
                  fillColor: Cesium.Color.BLACK,
                  outlineColor: Cesium.Color.WHITE,
                  outlineWidth: 2,
                  style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                },
                description: new Cesium.CallbackProperty((time) => {
                  return getDescription(
                    id,
                    onMessageData[id].name,
                    onMessageData[id].speed,
                    onMessageData[id].height,
                    onMessageData[id].headDirection,
                    onMessageData[id].time
                  );
                }, false),

                position: new Cesium.CallbackProperty((time) => {
                  const now = Cesium.JulianDate.now();
                  const duration = Cesium.JulianDate.secondsDifference(
                    now,
                    onMessageData[id].lastUpdateTime
                  );

                  const t = Math.min(duration / 1.5, 1.0);
                  if (onMessageData[id].currentDegreePosition !== undefined) {
                    if (
                      verifyDistancing(
                        anchorPointLon,
                        anchorPointLat,
                        onMessageData[id].currentDegreePosition.lon,
                        onMessageData[id].currentDegreePosition.lat
                      ) === "Inbound"
                    ) {
                      // Interpolate position between lastPosition and currentPosition
                      return Cesium.Cartesian3.lerp(
                        onMessageData[id].lastPosition,
                        onMessageData[id].currentPosition,
                        t,
                        new Cesium.Cartesian3()
                      );
                    } else {
                      return null;
                    }
                  }
                }, false), // 'false' because we're not directly using simulation time
                point: {
                  pixelSize: new Cesium.CallbackProperty((time) => {
                    if (onMessageData[id].currentDegreePosition !== undefined) {
                      if (
                        verifyDistancing(
                          anchorPointLon,
                          anchorPointLat,
                          onMessageData[id].currentDegreePosition.lon,
                          onMessageData[id].currentDegreePosition.lat
                        ) === "Inbound"
                      ) {
                        return 10;
                      } else {
                        return 0;
                      }
                    }
                  }, false),

                  color: new Cesium.CallbackProperty((time) => {
                    if (updatingData[id] > 30) {
                      return Cesium.Color.RED;
                    } else if (updatingData[id] > 10) {
                      return Cesium.Color.ORANGE;
                    } else {
                      return Cesium.Color.GREENYELLOW;
                    }
                  }, false),
                  zIndex: -1,
                },
                billboard: {
                  image: new Cesium.CallbackProperty((time) => {
                    if (onMessageData[id].currentDegreePosition !== undefined) {
                      if (
                        verifyDistancing(
                          anchorPointLon,
                          anchorPointLat,
                          onMessageData[id].currentDegreePosition.lon,
                          onMessageData[id].currentDegreePosition.lat
                        ) === "Inbound"
                      ) {
                        return returnImage(
                          validateTimeWithFlighting(
                            id,
                            onMessageData[id].currentDegreePosition
                          ),
                          onMessageData[id].name
                        );
                      } else {
                        return null;
                      }
                    }
                  }, false),
                  scale: 0.095,
                  ready: true,
                  rotation: new Cesium.CallbackProperty(() => {
                    const now = Cesium.JulianDate.now();
                    const duration = Cesium.JulianDate.secondsDifference(
                      now,
                      onMessageData[id].lastUpdateTime
                    );
                    const t = Math.min(duration / 1.5, 1.0); // Ensure interpolation factor is between 0 and 1

                    // Get last and current positions in Cartographic coordinates
                    const cartographicLast = Cesium.Cartographic.fromCartesian(
                      onMessageData[id].lastPosition
                    );
                    const cartographicCurrent =
                      Cesium.Cartographic.fromCartesian(
                        onMessageData[id].currentPosition
                      );

                    // Calculate the new heading (angle in radians)
                    const dx =
                      cartographicCurrent.longitude -
                      cartographicLast.longitude;
                    const dy =
                      cartographicCurrent.latitude - cartographicLast.latitude;
                    const currentRotation =
                      Math.atan2(dy, dx) - Cesium.Math.PI_OVER_TWO;

                    // Initialize lastRotation if not already set
                    if (!onMessageData[id].lastRotation) {
                      onMessageData[id].lastRotation = currentRotation;
                    }

                    // Interpolate between lastRotation and currentRotation
                    const interpolatedRotation = Cesium.Math.lerp(
                      onMessageData[id].lastRotation,
                      currentRotation,
                      t
                    );

                    // Update lastRotation for the next frame
                    onMessageData[id].lastRotation = interpolatedRotation;

                    return interpolatedRotation;
                  }, false),
                  zIndex: 1,
                  color: new Cesium.Color(1.0, 1.0, 1.0, 1.5),
                },
              });
              entityMap[id].flightHistoryPath = viewer.entities.add({
                id: `PI-${id}`,
                polyline: {
                  positions: new Cesium.CallbackProperty((time) => {
                    if (isClicking !== null) {
                      if (
                        onMessageData &&
                        onMessageData[isClicking]?.historyTrail &&
                        onMessageData[id] !== undefined
                      ) {
                        const now = Cesium.JulianDate.now();
                        const lastTime =
                          onMessageData[id].lastUpdateTime !== undefined
                            ? onMessageData[id].lastUpdateTime
                            : now;
                        const duration = Cesium.JulianDate.secondsDifference(
                          now,
                          lastTime
                        );
                        const t = Math.min(duration / 1.5, 1.0);
                        const linePath = onMessageData[isClicking].historyTrail;
                        if (linePath.length > 1) {
                          const start = linePath.slice(-2)[0];
                          const end = linePath.slice(-2)[1];
                          if (
                            onMessageData[id].currentDegreePosition !==
                            undefined
                          ) {
                            if (
                              verifyDistancing(
                                anchorPointLon,
                                anchorPointLat,
                                onMessageData[id].currentDegreePosition.lon,
                                onMessageData[id].currentDegreePosition.lat
                              ) === "Inbound"
                            ) {
                              // Interpolate between the last two positions
                              const interpolatedPosition =
                                Cesium.Cartesian3.lerp(
                                  start,
                                  end,
                                  t,
                                  new Cesium.Cartesian3()
                                );
                              return [
                                ...linePath.slice(0, -1),
                                interpolatedPosition,
                              ];
                            } else {
                              return null;
                            }
                          }
                        }
                      }
                    }
                    return null;
                  }, false),
                  width: trailWidth,
                  material: Cesium.Color.RED.withAlpha(0.5),
                },
              });
            }
          }

          //Count from 48 but end at 1.50
          const availableKeys = Object.keys(onMessageData);
          for (let id of availableKeys) {
            updatingData[id] = updatingData[id] + 1;
            if (updatingData[id] > 1 && updatingData[id] < 60) {
              console.log(
                `${id} \nis missing for ${updatingData[id] + 60} seconds`
              );
            }
            if (updatingData[id] >= 60) {
              if (id === isClicking) {
                isClicking = null;
              }
              viewer.entities.remove(entityMap[id].flightObject);
              viewer.entities.remove(entityMap[id].flightDrawingLine);
              delete entityMap[id];
              delete onMessageData[id];
              delete updatingData[id];
            }
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });

      updateRealTimeData(onMessageData);
    }, 1500);
  }, []);

  return (
    <>
      <div style={{ display: "flex" }}>
        <div
          ref={mapRef}
          style={{
            width: "100vw",
            height: "93.25vh",
          }}
        />
      </div>
    </>
  );
};

export default DroneMonitor;
